import { CHECK_SCREENING_MX, CHECK_SCREENING_MX_SUCCESS, RESET_SCREENING_MAMMOGRAFICO_STATE } from "./actionsType"

export const checkScreeningMXAction = () => ({
    type: CHECK_SCREENING_MX,
})

export const checkScreeningMXLActionSuccess = (payload) => ({
    type: CHECK_SCREENING_MX_SUCCESS,
    payload
})

export const resetScreeningMammograficoStateAction = () => ({
    type: RESET_SCREENING_MAMMOGRAFICO_STATE,
})